export default {
  id: 'caffe-template',
  title: 'Caffe template',
  icon: 'mdi-coffee',
  show: true,
  order: 16,
  children: [
    {
      id: 'cash-register-basics',
      title: 'Osnovno korištenje',
      icon: 'mdi-information-outline',
      show: true,
      order: 1,
      content: () => `
        <h2 id="cash-register-basics">Osnovno korištenje blagajne</h2>
        <p>
          Blagajna je glavni radni ekran za prodaju i naručivanje. Sastoji se od tri glavna dijela:
          grid s proizvodima, račun i panel za plaćanje.
        </p>

        <h3 class="mt-4">Dijelovi blagajne</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Dio</th>
              <th>Opis</th>
              <th>Pozicija</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Grid proizvoda</strong></td>
              <td>Prikazuje tile-ove (gumbe) za brzi odabir proizvoda i kategorija</td>
              <td>Gornji dio ekrana</td>
            </tr>
            <tr>
              <td><strong>Račun (Invoice)</strong></td>
              <td>Lista odabranih proizvoda s količinama i cijenama</td>
              <td>Donji lijevi dio</td>
            </tr>
            <tr>
              <td><strong>Panel za plaćanje</strong></td>
              <td>Gumbi za plaćanje, stolove, i ostale funkcije</td>
              <td>Donji desni dio</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Osnovni radni tok</h3>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Osnovni proces prodaje:</strong><br><br>
            1. Odaberite stol (za ugostiteljstvo) ili kreirajte novi račun<br>
            2. Kliknite na proizvode da ih dodate na račun<br>
            3. Prilagodite količine po potrebi<br>
            4. Odaberite način plaćanja<br>
            5. Zaključajte i ispišite račun
          </div>
        </div>

        <h3 class="mt-4">Grid proizvoda</h3>

        <h4 class="mt-3">Odabir proizvoda</h4>
        <p>Postoje dva načina za odabir proizvoda:</p>

        <ul>
          <li><strong>Direktan odabir</strong> - Kliknite direktno na tile proizvoda koji želite dodati</li>
          <li><strong>Odabir preko kategorije</strong> - Kliknite na kategoriju, zatim odaberite proizvod iz liste</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Koristite različite boje za kategorije da lakše pronađete proizvode.
            Često korištene proizvode stavite kao direktne tile-ove.
          </div>
        </div>

        <h4 class="mt-3">Uređivanje grida</h4>
        <p>Za prilagodbu rasporeda proizvoda:</p>

        <ol>
          <li>Kliknite na gumb <strong>"Uredi prikaz"</strong> u gornjem desnom kutu</li>
          <li>Kliknite na prazan tile ili postojeći za uređivanje</li>
          <li>Odaberite proizvod ili kategoriju</li>
          <li>Postavite boje i efekte (vidi sekciju "Izgled blagajne")</li>
          <li>Kliknite <strong>"Spremi i zatvori"</strong></li>
        </ol>

        <h3 class="mt-4">Račun (Invoice panel)</h3>

        <h4 class="mt-3">Stavke računa</h4>
        <p>Nakon što dodate proizvod, pojavljuje se u računu s sljedećim informacijama:</p>

        <ul>
          <li><strong>Naziv proizvoda</strong> - Ime odabranog proizvoda</li>
          <li><strong>Količina</strong> - Broj jedinica (može se mijenjati)</li>
          <li><strong>Cijena</strong> - Jedinična cijena</li>
          <li><strong>Ukupno</strong> - Količina × Cijena</li>
        </ul>

        <h4 class="mt-3">Akcije na stavkama</h4>

        <table class="info-table">
          <thead>
            <tr>
              <th>Akcija</th>
              <th>Kako</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Promjena količine</strong></td>
              <td>Klik na stavku → unesi novu količinu</td>
              <td>Mijenja broj komada</td>
            </tr>
            <tr>
              <td><strong>Povećanje količine</strong></td>
              <td>Klik na + gumb</td>
              <td>Dodaje +1 na količinu</td>
            </tr>
            <tr>
              <td><strong>Smanjenje količine</strong></td>
              <td>Klik na - gumb</td>
              <td>Oduzima -1 s količine</td>
            </tr>
            <tr>
              <td><strong>Brisanje stavke</strong></td>
              <td>Klik na X ili ikonu za brisanje</td>
              <td>Uklanja stavku s računa</td>
            </tr>
            <tr>
              <td><strong>Dodavanje popusta</strong></td>
              <td>Klik na stavku → "Popust"</td>
              <td>Primjenjuje popust na stavku</td>
            </tr>
            <tr>
              <td><strong>Dodavanje napomene</strong></td>
              <td>Klik na stavku → "Napomena"</td>
              <td>Dodaje posebne zahtjeve (npr. "bez luka")</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">Ukupni iznos</h4>
        <p>Na dnu računa prikazuju se:</p>

        <ul>
          <li><strong>Zbroj</strong> - Ukupna cijena svih stavki</li>
          <li><strong>Popust</strong> - Ukupan iznos popusta (ako postoji)</li>
          <li><strong>UKUPNO</strong> - Konačan iznos za naplatu</li>
        </ul>

        <h3 class="mt-4">Panel za plaćanje</h3>

        <h4 class="mt-3">Glavni gumbi</h4>

        <table class="info-table">
          <thead>
            <tr>
              <th>Gumb</th>
              <th>Funkcija</th>
              <th>Kada koristiti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Gotovina</strong></td>
              <td>Plaćanje gotovinom</td>
              <td>Kupac plaća u gotovini</td>
            </tr>
            <tr>
              <td><strong>Kartica</strong></td>
              <td>Plaćanje karticom</td>
              <td>Kupac plaća debitnom/kreditnom karticom</td>
            </tr>
            <tr>
              <td><strong>Transakcijski račun</strong></td>
              <td>Plaćanje transakcijom/virmanom</td>
              <td>Za B2B kupce ili odgođena plaćanja</td>
            </tr>
            <tr>
              <td><strong>Mješovito</strong></td>
              <td>Kombinacija načina plaćanja</td>
              <td>Dio gotovina, dio kartica</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">Pomoćni gumbi</h4>

        <table class="info-table">
          <thead>
            <tr>
              <th>Gumb</th>
              <th>Ikona</th>
              <th>Funkcija</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Stolovi</strong></td>
              <td>🪑</td>
              <td>Otvara listu stolova, omogućava odabir, spajanje, dijeljenje stolova</td>
            </tr>
            <tr>
              <td><strong>Pretraživanje</strong></td>
              <td>🔍</td>
              <td>Pretraživanje proizvoda po imenu ili šifri</td>
            </tr>
            <tr>
              <td><strong>Računi</strong></td>
              <td>📄</td>
              <td>Pregled izdanih računa, storno, kopija</td>
            </tr>
            <tr>
              <td><strong>Popust</strong></td>
              <td>%</td>
              <td>Dodavanje popusta na cijeli račun</td>
            </tr>
            <tr>
              <td><strong>Brisanje</strong></td>
              <td>🗑️</td>
              <td>Brisanje cijelog računa ili odabranih stavki</td>
            </tr>
            <tr>
              <td><strong>Zatvaranje smjene</strong></td>
              <td>💰</td>
              <td>Zatvaranje blagajne i izvještaj o dnevnoj prodaji</td>
            </tr>
            <tr>
              <td><strong>Napomene</strong></td>
              <td>📝</td>
              <td>Dodavanje napomena za kuhinju/bar</td>
            </tr>
            <tr>
              <td><strong>Novi stol</strong></td>
              <td>➕</td>
              <td>Kreiranje novog stola ili računa</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Rad sa stolovima (za ugostiteljstvo)</h3>

        <h4 class="mt-3">Odabir stola</h4>
        <ol>
          <li>Kliknite na gumb <strong>"Stolovi"</strong></li>
          <li>Odaberite stol iz liste</li>
          <li>Stol će se učitati s postojećim narudžbama (ako postoje)</li>
        </ol>

        <h4 class="mt-3">Kreiranje novog stola</h4>
        <ol>
          <li>Kliknite na <strong>"Novi stol"</strong> (+)</li>
          <li>Automatski se kreira novi stol s rednim brojem</li>
          <li>Počnite dodavati proizvode</li>
        </ol>

        <h4 class="mt-3">Spajanje stolova</h4>
        <p>Ako gosti sjede na više stolova, možete spojiti račune:</p>
        <ol>
          <li>Otvorite prvi stol</li>
          <li>Kliknite na opciju <strong>"Spoji stolove"</strong></li>
          <li>Odaberite drugi stol koji želite spojiti</li>
          <li>Sve stavke će biti na jednom računu</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Spajanje stolova je nepovratna akcija.
            Provjerite prije nego što potvrdite.
          </div>
        </div>

        <h4 class="mt-3">Dijeljenje računa</h4>
        <p>Ako gosti žele odvojene račune:</p>
        <ol>
          <li>Otvorite stol</li>
          <li>Odaberite stavke koje želi jedan gost</li>
          <li>Kliknite <strong>"Podijeli račun"</strong></li>
          <li>Kreirat će se novi stol s odabranim stavkama</li>
          <li>Naplatite svaki stol zasebno</li>
        </ol>

        <h3 class="mt-4">Proces plaćanja</h3>

        <h4 class="mt-3">Gotovina</h4>
        <ol>
          <li>Provjerite ukupan iznos na računu</li>
          <li>Kliknite <strong>"Gotovina"</strong></li>
          <li>Unesite primljeni iznos (ili kliknite "Točan iznos")</li>
          <li>Sustav izračunava povrat</li>
          <li>Kliknite <strong>"Zaključaj"</strong></li>
          <li>Račun se ispisuje automatski</li>
        </ol>

        <h4 class="mt-3">Kartica</h4>
        <ol>
          <li>Kliknite <strong>"Kartica"</strong></li>
          <li>Provjerite iznos</li>
          <li>Provedite transakciju na POS terminalu</li>
          <li>Kliknite <strong>"Zaključaj"</strong></li>
          <li>Račun se ispisuje automatski</li>
        </ol>

        <h4 class="mt-3">Mješovito plaćanje</h4>
        <ol>
          <li>Kliknite <strong>"Mješovito"</strong></li>
          <li>Unesite iznos gotovine</li>
          <li>Unesite iznos kartice</li>
          <li>Provjerite da se iznosi slažu s ukupnim</li>
          <li>Kliknite <strong>"Zaključaj"</strong></li>
        </ol>

        <h3 class="mt-4">Napomene za kuhinju/bar</h3>

        <p>Za restorane i caffe barove, napomene služe za komunikaciju s kuhinjom:</p>

        <h4 class="mt-3">Dodavanje napomene na stavku</h4>
        <ol>
          <li>Kliknite na stavku na računu</li>
          <li>Odaberite <strong>"Dodaj napomenu"</strong></li>
          <li>Upišite napomenu (npr. "bez luka", "dobro pečeno")</li>
          <li>Napomena će biti ispisana na kuhinji</li>
        </ol>

        <h4 class="mt-3">Slanje narudžbe</h4>
        <ol>
          <li>Nakon što dodate sve proizvode</li>
          <li>Kliknite <strong>"Pošalji narudžbu"</strong> ili ikonu za slanje</li>
          <li>Narudžba se ispisuje na kuhinskom printeru</li>
          <li>Stol ostaje otvoren za dodavanje</li>
        </ol>

        <h3 class="mt-4">Pretraživanje proizvoda</h3>

        <p>Ako ne možete pronaći proizvod u gridu:</p>

        <ol>
          <li>Kliknite na gumb <strong>"Pretraživanje"</strong> (🔍)</li>
          <li>Upišite naziv proizvoda ili šifru</li>
          <li>Odaberite proizvod iz rezultata</li>
          <li>Proizvod se dodaje na račun</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Pro savjet:</strong> Koristite tipkovnicu za brže unose.
            Mnogi gumbi imaju prečace (shortcuts) - držite Space da vidite dostupne prečace.
          </div>
        </div>

        <h3 class="mt-4">Popusti</h3>

        <h4 class="mt-3">Popust na stavku</h4>
        <ol>
          <li>Kliknite na stavku</li>
          <li>Odaberite <strong>"Popust"</strong></li>
          <li>Unesite postotak ili fiksni iznos</li>
          <li>Cijena se automatski ažurira</li>
        </ol>

        <h4 class="mt-3">Popust na cijeli račun</h4>
        <ol>
          <li>Kliknite na gumb <strong>"Popust"</strong> (%) u panelu za plaćanje</li>
          <li>Odaberite tip popusta (postotak/iznos)</li>
          <li>Unesite vrijednost</li>
          <li>Ukupan iznos se ažurira</li>
        </ol>

        <h3 class="mt-4">Zatvaranje smjene</h3>

        <p>Na kraju radnog dana ili smjene:</p>

        <ol>
          <li>Zatvorite sve otvorene stolove</li>
          <li>Kliknite na <strong>"Zatvaranje smjene"</strong> (💰)</li>
          <li>Sustav prikazuje izvještaj:
            <ul>
              <li>Ukupna prodaja</li>
              <li>Gotovina u blagajni</li>
              <li>Kartično plaćanje</li>
              <li>Broj računa</li>
            </ul>
          </li>
          <li>Provjerite novac u blagajni</li>
          <li>Unesite stvarni iznos gotovine</li>
          <li>Sustav prikazuje razliku (višak/manjak)</li>
          <li>Zaključajte smjenu</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Ne zatvarajte smjenu dok god imate otvorene stolove!
            Svi stolovi moraju biti naplaćeni prije zatvaranja smjene.
          </div>
        </div>

        <h3 class="mt-4">Pregled i storniranje računa</h3>

        <h4 class="mt-3">Pregled izdanih računa</h4>
        <ol>
          <li>Kliknite na <strong>"Računi"</strong> (📄)</li>
          <li>Prikazuje se lista svih računa</li>
          <li>Možete filtrirati po datumu, vremenu, načinu plaćanja</li>
          <li>Kliknite na račun za detalje</li>
        </ol>

        <h4 class="mt-3">Storniranje računa</h4>
        <ol>
          <li>Otvorite pregled računa</li>
          <li>Pronađite račun koji trebate stornirati</li>
          <li>Kliknite <strong>"Storniraj"</strong></li>
          <li>Unesite razlog storniranja (obavezno!)</li>
          <li>Potvrdite storno</li>
          <li>Storno račun se automatski ispisuje</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Storniranje računa ostavlja traga u sustavu.
            Koristite samo kada je zaista potrebno (greška, povrat robe, itd.).
          </div>
        </div>

        <h4 class="mt-3">Kopija računa</h4>
        <p>Ako kupac zatraži kopiju:</p>
        <ol>
          <li>Otvorite pregled računa</li>
          <li>Pronađite račun</li>
          <li>Kliknite <strong>"Ispiši kopiju"</strong></li>
          <li>Na kopiji piše "KOPIJA"</li>
        </ol>

        <h3 class="mt-4">Tipkovnički prečaci</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Prečac</th>
              <th>Akcija</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Space</strong></td>
              <td>Prikaži sve dostupne prečace</td>
            </tr>
            <tr>
              <td><strong>F1</strong></td>
              <td>Stolovi</td>
            </tr>
            <tr>
              <td><strong>F2</strong></td>
              <td>Pretraživanje proizvoda</td>
            </tr>
            <tr>
              <td><strong>F3</strong></td>
              <td>Pregled računa</td>
            </tr>
            <tr>
              <td><strong>F4</strong></td>
              <td>Plaćanje gotovinom</td>
            </tr>
            <tr>
              <td><strong>F5</strong></td>
              <td>Plaćanje karticom</td>
            </tr>
            <tr>
              <td><strong>Delete</strong></td>
              <td>Brisanje odabrane stavke</td>
            </tr>
            <tr>
              <td><strong>Esc</strong></td>
              <td>Zatvaranje dijaloga</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Kako dodati proizvod koji nije u gridu?</h4>
        <p>
          Koristite funkciju pretraživanja (🔍 ili F2). Upišite naziv ili šifru proizvoda i odaberite ga iz rezultata.
        </p>

        <h4 class="mt-3">Što ako pogrešno dodam proizvod?</h4>
        <p>
          Kliknite na stavku i pritisnite Delete, ili kliknite na X ikonu pokraj stavke.
          Ako ste već poslali narudžbu u kuhinju, možda ćete morati stornirati stavku.
        </p>

        <h4 class="mt-3">Mogu li promijeniti cijenu proizvoda?</h4>
        <p>
          Cijena se postavlja u cjeniku i ne može se mijenjati direktno na blagajni (sigurnosni razlog).
          Koristite popust ako trebate sniziti cijenu.
        </p>

        <h4 class="mt-3">Što ako mi nestane papira u printeru?</h4>
        <p>
          Dopunite papir i ponovno pokušajte ispisati račun. Sustav zadržava račun dok se ne ispiše uspješno.
          U pregledu računa možete ispisati kopiju.
        </p>

        <h4 class="mt-3">Kako otkazati račun prije plaćanja?</h4>
        <p>
          Kliknite na gumb za brisanje (🗑️) i potvrdite brisanje cijelog računa.
          Za stolove, ovo će zatvoriti stol i izbrisati sve stavke.
        </p>

        <h4 class="mt-3">Mogu li raditi bez interneta?</h4>
        <p>
          Sustav može raditi offline u ograničenom modu. Računi će se sinkronizirati čim se internet vrati.
          Preporučujemo stabilan internet za najbolje iskustvo.
        </p>
      `
    },
    {
      id: 'cash-register-appearance',
      title: 'Izgled blagajne',
      icon: 'mdi-palette',
      show: true,
      order: 2,
      content: () => `
        <h2 id="cash-register-appearance">Izgled blagajne - Konfiguracija tileova</h2>
        <p>
          Blagajna omogućava potpuno prilagođavanje izgleda tileova (gumbova) za kategorije i proizvode.
          Možete postaviti boje, gradijente i vizualne efekte koji čine rad na blagajni intuitivnijim i vizualno atraktivnijim.
        </p>

        <h3 class="mt-4">Pristup konfiguraciji</h3>

        <ol>
          <li>Na ekranu blagajne, kliknite na <strong>"Uredi prikaz"</strong> ili ekvivalentni gumb za uređivanje</li>
          <li>Kliknite na tile koji želite urediti</li>
          <li>Otvorit će se dijalog s opcijama za konfiguraciju</li>
        </ol>

        <h3 class="mt-4">Osnovne opcije</h3>

        <h4 class="mt-3">1. Odabir kategorije ili proizvoda</h4>
        <p>U dropdown menijima odaberite:</p>
        <ul>
          <li><strong>Kategorija</strong> - Za brzi pristup svim proizvodima iz kategorije</li>
          <li><strong>Proizvod</strong> - Za izravan odabir proizvoda</li>
        </ul>

        <h4 class="mt-3">2. Pregled</h4>
        <p>
          U sredini dijaloga vidjet ćete <strong>pregled</strong> kako će tile izgledati.
          Svi efekti se primjenjuju u realnom vremenu, tako da odmah vidite kako će izgledati.
        </p>

        <h4 class="mt-3">3. Boja pozadine</h4>

        <table class="info-table">
          <thead>
            <tr>
              <th>Opcija</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Solid boja</strong></td>
              <td>Jedna boja za cijeli tile</td>
            </tr>
            <tr>
              <td><strong>Gradient</strong></td>
              <td>Preljev između dvije boje (označite "Koristi gradient")</td>
            </tr>
            <tr>
              <td><strong>Boja teksta</strong></td>
              <td>Boja za naziv proizvoda/kategorije na tile-u</td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Prethodni stil:</strong> Označite "Koristi prethodni stil" da upotrijebite boje i efekte s prethodnog tile-a.
          </div>
        </div>

        <h3 class="mt-4">Vizualni efekti</h3>

        <p>
          Dostupno je <strong>13 vizualnih efekata</strong> koje možete primijeniti na tile.
          Efekte možete kombinirati za postizanje jedinstvenog izgleda!
        </p>

        <h4 class="mt-3">Osnovni efekti</h4>

        <table class="info-table">
          <thead>
            <tr>
              <th>Efekt</th>
              <th>Opis</th>
              <th>Kada koristiti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Glass effect (staklo)</strong></td>
              <td>Prozirni stakleni efekt s blur efektom i refleksijom</td>
              <td>Za moderan, elegantan izgled</td>
            </tr>
            <tr>
              <td><strong>3D effect (sjenčanje)</strong></td>
              <td>Dubinski efekt s višestrukim sjenama</td>
              <td>Za istaknutu, fizičku dimenziju</td>
            </tr>
            <tr>
              <td><strong>Neon/Glow effect</strong></td>
              <td>Efekt sjaja/svjetlucanja oko ruba</td>
              <td>Za istaknute kategorije ili promocije</td>
            </tr>
            <tr>
              <td><strong>Pulse effect (pulsiranje)</strong></td>
              <td>Animacija pulsa - tile se lagano povećava/smanjuje</td>
              <td>Za privlačenje pažnje na posebne ponude</td>
            </tr>
            <tr>
              <td><strong>Neumorphism (soft UI)</strong></td>
              <td>Mekani, soft UI dizajn s dvostrukim sjenama</td>
              <td>Za suptilan, soft dizajn</td>
            </tr>
            <tr>
              <td><strong>Gradient border</strong></td>
              <td>Animirani gradijent na rubu tile-a</td>
              <td>Za dinamičan, živahan izgled</td>
            </tr>
            <tr>
              <td><strong>Shimmer/Sparkle</strong></td>
              <td>Efekt "iskre" koja prelazi preko tile-a</td>
              <td>Za luksuzne proizvode</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">Dodatni efekti</h4>

        <table class="info-table">
          <thead>
            <tr>
              <th>Efekt</th>
              <th>Opis</th>
              <th>Kada koristiti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Floating (lebdenje)</strong></td>
              <td>Tile se lagano podiže i spušta</td>
              <td>Za proizvode koji "lete s polica"</td>
            </tr>
            <tr>
              <td><strong>Shadow lift (izdizanje)</strong></td>
              <td>Tile izgleda kao da je podignut iznad površine</td>
              <td>Za VIP kategorije ili premium proizvode</td>
            </tr>
            <tr>
              <td><strong>Holographic (hologram)</strong></td>
              <td>Holografski efekt s duga bojama</td>
              <td>Za specijalne ponude ili sezonske proizvode</td>
            </tr>
            <tr>
              <td><strong>Frost (led)</strong></td>
              <td>Ledeni, frozen izgled s kristalima</td>
              <td>Za hladna pića, sladolede</td>
            </tr>
            <tr>
              <td><strong>Border glow (rub)</strong></td>
              <td>Suptilno svjetlucanje samo oko ruba</td>
              <td>Za diskretno isticanje važnih kategorija</td>
            </tr>
            <tr>
              <td><strong>Breathing (disanje)</strong></td>
              <td>Lagano "disanje" - mijenja opacity</td>
              <td>Za opuštajući, smirujući efekt</td>
            </tr>
          </tbody>
        </table>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Možete kombinirati više efekata! Na primjer, kombinirajte Glass + 3D za dubinu,
            ili Frost + Floating za ledene napitke koji "lebde".
          </div>
        </div>

        <h3 class="mt-4">Korak po korak: Dodavanje tile-a</h3>

        <h4 class="mt-3">1. Ulazak u mod uređivanja</h4>
        <ol>
          <li>Na ekranu blagajne, kliknite <strong>"Uredi prikaz"</strong></li>
          <li>Prikazat će se toolbar s opcijama za uređivanje</li>
        </ol>

        <h4 class="mt-3">2. Odabir tile-a</h4>
        <ol>
          <li>Kliknite na prazan tile ili odaberite postojeći</li>
          <li>Kliknite <strong>"Uredi"</strong> u toolbaru</li>
        </ol>

        <h4 class="mt-3">3. Konfiguracija tile-a</h4>
        <ol>
          <li>Odaberite <strong>kategoriju</strong> ili <strong>proizvod</strong> iz dropdown liste</li>
          <li>Odaberite da li želite <strong>gradient</strong> ili solid boju</li>
          <li>Odaberite <strong>boje</strong>:
            <ul>
              <li><strong>Boja pozadine</strong> ili <strong>Boja 1/Boja 2</strong> (za gradient)</li>
              <li><strong>Boja teksta</strong></li>
            </ul>
          </li>
          <li>Označite željene <strong>vizualne efekte</strong> (možete odabrati više)</li>
          <li>Provjerite <strong>pregled</strong> - vidjet ćete kako će tile izgledati</li>
          <li>Kliknite <strong>"Dodaj kategoriju"</strong> ili <strong>"Dodaj proizvod"</strong></li>
        </ol>

        <h4 class="mt-3">4. Spremanje</h4>
        <ol>
          <li>Nakon što ste dodali sve tile-ove, kliknite <strong>"Spremi i zatvori"</strong> u toolbaru</li>
          <li>Konfiguracija će biti spremljena u bazu i automatski učitana prilikom sljedećeg pokretanja</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Sve promjene se automatski spremaju u Firebase bazu podataka.
            Nakon zatvaranja moda uređivanja, vaš raspored će biti sačuvan.
          </div>
        </div>

        <h3 class="mt-4">Dodatne funkcije</h3>

        <h4 class="mt-3">Spajanje ćelija (merge)</h4>
        <p>Možete spojiti više tile-ova u jednu veću ćeliju:</p>
        <ol>
          <li>Držite <strong>Ctrl</strong> (ili <strong>Cmd</strong> na Mac-u) i kliknite više tile-ova</li>
          <li>Kliknite <strong>"Spoji"</strong> u toolbaru</li>
          <li>Tile-ovi će se spojiti u jedan veliki tile</li>
        </ol>

        <h4 class="mt-3">Razdvajanje ćelija (unmerge)</h4>
        <ol>
          <li>Odaberite spojeni tile</li>
          <li>Kliknite <strong>"Razdvoji"</strong> u toolbaru</li>
          <li>Tile će se razdvojiti natrag u pojedinačne ćelije</li>
        </ol>

        <h4 class="mt-3">Brisanje tile-a</h4>
        <ol>
          <li>Odaberite tile koji želite ukloniti</li>
          <li>Kliknite <strong>"Ukloni"</strong> u toolbaru</li>
          <li>Tile će postati prazan</li>
        </ol>

        <h4 class="mt-3">Promjena dimenzija rešetke</h4>
        <p>U toolbaru možete promijeniti broj redova i stupaca:</p>
        <ul>
          <li><strong>Redaka</strong>: 1-12 redova</li>
          <li><strong>Stupaca</strong>: 1-12 stupaca</li>
        </ul>

        <h4 class="mt-3">Spremanje prikaza</h4>
        <p>Možete spremiti više različitih prikaza:</p>
        <ol>
          <li>Konfigurirajte tile-ove kako želite</li>
          <li>Kliknite <strong>"Spremi kao"</strong></li>
          <li>Unesite naziv (npr. "Jutarnji menu", "Večernji menu")</li>
          <li>Prikaz će biti spremljen i možete ga učitati kasnije</li>
        </ol>

        <h3 class="mt-4">Primjeri konfiguracija</h3>

        <h4 class="mt-3">Primjer 1: Caffe bar - Kava</h4>
        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Kategorija:</strong> Kava<br>
            <strong>Boja:</strong> Gradient od tamnosmeđe (#6B4423) do svijetlosmeđe (#C8A882)<br>
            <strong>Boja teksta:</strong> Bijela (#FFFFFF)<br>
            <strong>Efekti:</strong> 3D effect + Shimmer<br>
            <strong>Rezultat:</strong> Profesionalni, bogat izgled kao šalica kave s sjajnom površinom
          </div>
        </div>

        <h4 class="mt-3">Primjer 2: Hladna pića</h4>
        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Kategorija:</strong> Hladna pića<br>
            <strong>Boja:</strong> Gradient od plave (#4FC3F7) do svijetloplave (#B3E5FC)<br>
            <strong>Boja teksta:</strong> Tamno plava (#01579B)<br>
            <strong>Efekti:</strong> Frost + Floating<br>
            <strong>Rezultat:</strong> Ledeni izgled koji izgleda kao da lebdi - savršen za hladne napitke
          </div>
        </div>

        <h4 class="mt-3">Primjer 3: Specijalna ponuda</h4>
        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Proizvod:</strong> Dnevna ponuda<br>
            <strong>Boja:</strong> Gradient od narančaste (#FF6B00) do žute (#FFD54F)<br>
            <strong>Boja teksta:</strong> Bijela (#FFFFFF)<br>
            <strong>Efekti:</strong> Pulse + Neon + Gradient border<br>
            <strong>Rezultat:</strong> Dinamičan, pulsirajući tile koji odmah privlači pažnju
          </div>
        </div>

        <h4 class="mt-3">Primjer 4: VIP proizvod</h4>
        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Proizvod:</strong> Champagne<br>
            <strong>Boja:</strong> Crna (#1A1A1A)<br>
            <strong>Boja teksta:</strong> Zlatna (#FFD700)<br>
            <strong>Efekti:</strong> Shadow lift + Shimmer + Border glow<br>
            <strong>Rezultat:</strong> Luksuzni, elegantan izgled savršen za premium proizvode
          </div>
        </div>

        <h3 class="mt-4">Najbolje prakse</h3>

        <table class="info-table">
          <thead>
            <tr>
              <th>Pravilo</th>
              <th>Preporuka</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Kontrast</strong></td>
              <td>Osigurajte dobar kontrast između boje pozadine i teksta</td>
            </tr>
            <tr>
              <td><strong>Konzistentnost</strong></td>
              <td>Koristite sličnu paletu boja za povezane kategorije</td>
            </tr>
            <tr>
              <td><strong>Umjerenost</strong></td>
              <td>Nemojte koristiti previše efekata odjednom (max 2-3)</td>
            </tr>
            <tr>
              <td><strong>Čitljivost</strong></td>
              <td>Osigurajte da se tekst može jasno pročitati</td>
            </tr>
            <tr>
              <td><strong>Svrha</strong></td>
              <td>Koristite jače efekte samo za važne kategorije</td>
            </tr>
            <tr>
              <td><strong>Testiranje</strong></td>
              <td>Testirajte na stvarnim uvjetima osvjetljenja</td>
            </tr>
          </tbody>
        </table>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Pro savjet:</strong> Započnite s jednostavnim konfiguracijama. Nakon što naučite kako efekti rade,
            možete eksperimentirati s kombinacijama za postizanje jedinstvenog izgleda vaše blagajne.
          </div>
        </div>

        <h3 class="mt-4">Često postavljana pitanja</h3>

        <h4 class="mt-3">Mogu li kombinirati sve efekte odjednom?</h4>
        <p>
          Tehnički da, ali nije preporučljivo. Kombinirajte maksimalno 2-3 efekta za najbolji rezultat.
          Previše efekata može usporiti pregledač i stvoriti vizualni kaos.
        </p>

        <h4 class="mt-3">Hoće li se moja konfiguracija izgubiti nakon refresha?</h4>
        <p>
          Ne! Sve promjene se automatski spremaju u Firebase bazu podataka.
          Čak i ako zatvorite pregledač ili isključite računalo, vaša konfiguracija će ostati spremljena.
        </p>

        <h4 class="mt-3">Mogu li kopirati izgled jednog tile-a na drugi?</h4>
        <p>
          Da! Označite "Koristi prethodni stil" kada dodajete novi tile.
          Sustav će automatski primjeniti boje i efekte s prethodnog tile-a.
        </p>

        <h4 class="mt-3">Što ako efekti izgledaju drugačije na različitim uređajima?</h4>
        <p>
          Neki efekti (npr. backdrop-filter za glass efekt) mogu izgledati različito ovisno o pregledniku.
          Testirajte na svim uređajima koje ćete koristiti.
        </p>

        <h4 class="mt-3">Kako resetirati tile na zadane postavke?</h4>
        <p>
          Jednostavno odaberite tile i kliknite "Ukloni". Zatim dodajte tile iznova bez odabira efekata.
        </p>

        <h4 class="mt-3">Mogu li imati različite prikaze za različite smjene?</h4>
        <p>
          Da! Koristite funkciju "Spremi kao" da spremite više prikaza (npr. "Jutro", "Večer", "Vikend").
          Prije početka smjene samo učitajte odgovarajući prikaz.
        </p>
      `
    },
    {
      id: 'keyboard-shortcuts',
      title: 'Keyboard shortcuts',
      icon: 'mdi-keyboard',
      show: true,
      order: 3,
      content: () => `
        <h2 id="shortcuts">Upute za korištenje keyboard shortcuts</h2>
        <p>
          Keyboard shortcuts omogućavaju brži rad na blagajni. Sustav automatski generira prečace za kategorije, artikle, stolove i prostorije.
        </p>

        <h3 class="mt-4">📋 Kako se kreiraju shortcuts</h3>
        <ul>
          <li>
            <strong>Kategorije:</strong> Dobivaju brojeve 1-9 prema redoslijedu
          </li>
          <li>
            <strong>Proizvodi:</strong> Prvih slova prvih 2 riječi naziva
            (npr. "Coca Cola" → CC)
          </li>
          <li>
            <strong>Sobe (Room tabs):</strong> Prvo slovo naziva sobe (npr.
            "Terasa" → T, "Restoran" → R)
            <ul style="margin-top: 8px;">
              <li>
                Ako ima više soba s istim slovom → dodaje se broj (T, T1,
                T2...)
              </li>
              <li>Koristi se za prebacivanje između tab-ova na tlocrtu</li>
            </ul>
          </li>
          <li>
            <strong>Prostorije (Areas):</strong> Prvo slovo naziva
            prostorije (npr. "Terasa" → T, "Bar" → B)
            <ul style="margin-top: 8px;">
              <li>Prostorije su pravokutne zone na tlocrtu</li>
              <li>
                Ako ima više prostorija s istim slovom → dodaje se broj (T,
                T1, T2...)
              </li>
            </ul>
          </li>
          <li>
            <strong>Stolovi i Barovi:</strong> Brojevi iz naziva (prva 3
            broja):
            <ul style="margin-top: 8px;">
              <li>"Stol 1" → 1</li>
              <li>"Stol 21" → 21</li>
              <li>"Stol 311" → 311</li>
              <li>
                Ako nema broja u nazivu → dobiva broj od 100 nadalje (100,
                101, 102...)
              </li>
              <li>
                Ako je broj dupliciran → dodaje se prefix
                <strong>X</strong> (npr. X1, X21)
              </li>
              <li>
                <strong>Tipkovnica:</strong> Utipkajte samo broj stola (npr.
                1, 21, 100)
              </li>
              <li>
                <strong>Prikaz na blagajni:</strong> Slovo prostorije + broj
                stola (npr. T1, T21, B100)
              </li>
            </ul>
          </li>
        </ul>

        <h3 class="mt-4">⚠️ Iznimke i pravila</h3>
        <ul>
          <li>
            <strong>Normalizacija znakova:</strong> Hrvatska slova se prvo
            pretvaraju u engleska
            <ul style="margin-top: 8px;">
              <li>š, Š → s, S</li>
              <li>č, Č → c, C</li>
              <li>ć, Ć → c, C</li>
              <li>ž, Ž → z, Z</li>
              <li>đ, Đ → d, D</li>
              <li>
                Primjer: "Štruca kruha" → shortcut je <strong>SK</strong>
              </li>
              <li>
                Primjer: "Češko pivo" → shortcut je <strong>CP</strong>
              </li>
            </ul>
          </li>
          <li>
            Ako shortcut počinje s <strong>brojem</strong> → automatski se
            dodaje prefix <strong>X</strong>
          </li>
          <li>
            <strong>SVA rezervirana slova zamijenjuju se sa 'X'</strong> u
            cijelom shortcutu (bilo gdje da se pojave)
          </li>
          <li>
            <strong>Primjer:</strong> proizvod "5 minuta" → shortcut je
            <strong>X5M</strong> (počinje s brojem)
          </li>
          <li>
            <strong>Primjer:</strong> proizvod "Sok" → shortcut je
            <strong>X</strong> (S se zamijeni sa X)
          </li>
          <li>
            <strong>Primjer:</strong> proizvod "Kava" → shortcut je
            <strong>XA</strong> (K se zamijeni sa X)
          </li>
          <li>
            <strong>Primjer:</strong> proizvod "Special Offer" → shortcut
            je <strong>XX</strong> (S→X, O→X)
          </li>
          <li>
            <strong>Primjer:</strong> proizvod "Fresh Tea" → shortcut je
            <strong>XX</strong> (F→X, T→X)
          </li>
        </ul>

        <h3 class="mt-4">🔒 Rezervirana slova (za gumbe)</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Slovo</th>
              <th>Gumb</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span style="background: #3989C9; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">F</span></td>
              <td>Pretraga</td>
              <td>Otvara dialog za pretragu artikala</td>
            </tr>
            <tr>
              <td><span style="background: #3989C9; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">T</span></td>
              <td>Stolovi</td>
              <td>
                Otvara tlocrt stolova ili popis stolova (ovisno o
                postavci)
              </td>
            </tr>
            <tr>
              <td><span style="background: #3989C9; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">S</span></td>
              <td>Spremi</td>
              <td>Sprema narudžbu na stol</td>
            </tr>
            <tr>
              <td><span style="background: #3989C9; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">O</span></td>
              <td>Očisti</td>
              <td>Briše narudžbu sa stola</td>
            </tr>
            <tr>
              <td><span style="background: #3989C9; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">G</span></td>
              <td>Gotovina</td>
              <td>Plaćanje gotovinom</td>
            </tr>
            <tr>
              <td><span style="background: #3989C9; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">K</span></td>
              <td>Kartično</td>
              <td>Plaćanje karticom</td>
            </tr>
            <tr>
              <td><span style="background: #4CAF50; color: white; padding: 4px 12px; border-radius: 4px; font-weight: 600; font-size: 12px;">Enter</span></td>
              <td>Plaćanje</td>
              <td>Otvara modal za odabir načina plaćanja (Gotovina/Kartično/R1)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">⏱️ Privremeni prikaz shortcuts-a</h3>
        <ul>
          <li>
            Pritisnite i držite tipku
            <strong>Space (razmaknica)</strong> duže od 600ms (0.6 sekundi)
          </li>
          <li>
            Privremeno će se prikazati
            <strong>svi shortcut badgevi</strong> na ekranu
          </li>
          <li>
            Badge-vi će ostati vidljivi dok god držite tipku
            <strong>Space (razmaknica)</strong>
          </li>
          <li>
            Kada pustite tipku, badge-vi se skrivaju (osim ako je opcija
            "Prikaži shortcuts na ekranu" uključena)
          </li>
          <li>
            Korisno za pregled svih dostupnih shortcuts-a bez uključivanja
            stalne prikazivanja
          </li>
          <li>
            <strong>Zašto Space?</strong> Tipka Space se koristi jer slovo
            'S' je rezervirano za funkciju "Spremi"
          </li>
        </ul>

        <h3 class="mt-4">💡 Dodatne napomene</h3>
        <ul>
          <li>
            Shortcuts su jedinstveni po tipu (proizvodi, stolovi,
            prostorije)
          </li>
          <li>Shortcuts ne rade dok tipkate u input polju</li>
          <li>
            Shortcuts za gumbe ne rade ako je gumb onemogućen (disabled)
          </li>
          <li>
            Za višeslovna imena proizvoda možete upisati više slova
            uzastopno
          </li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Keyboard shortcuts omogućavaju znatno brži rad na blagajni. Sustav automatski generira shortcuts za sve artikle, kategorije i stolove prema gore navedenim pravilima.
          </div>
        </div>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Omogućavanje shortcuts-a:</strong> Keyboard shortcuts se mogu omogućiti/onemogućiti u postavkama blagajne (Konfiguracija → Keyboard Shortcuts).
          </div>
        </div>
      `
    },
    {
      id: 'cash-register-configuration',
      title: 'Konfiguracija',
      icon: 'mdi-cog',
      show: true,
      order: 4,
      content: () => `
        <h2 id="cash-register-configuration">Konfiguracija blagajne</h2>
        <p><strong>Konfiguracija</strong> omogućava prilagodbu vizualnih i funkcionalnih postavki blagajne prema vašim potrebama. Ovdje možete konfigurirati keyboard shortcuts, barcode scanner, način prikaza i ponašanje blagajne.</p>

        <h2 id="how-to-access" class="mt-6">Kako pristupiti konfiguraciji</h2>
        <ol>
          <li>Otvorite blagajnu</li>
          <li>U gornjem desnom kutu kliknite na <strong><v-icon small class="mr-1" style="vertical-align: middle; color: #3989C9;">mdi-cog</v-icon> Gear (zupčanik) ikonu</strong></li>
          <li>Otvara se dropdown menu s opcijama</li>
          <li>Kliknite na <strong>"Izgled blagajne"</strong></li>
          <li>Otvara se dialog s postavkama</li>
        </ol>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Lokacija:</strong> Gear button je uvijek vidljiv u top baru blagajne, desno od naziva stolova/narudžbi.
          </div>
        </div>

        <h2 id="settings-options" class="mt-6">Postavke i opcije</h2>

        <h3 class="mt-4">1. Keyboard Shortcuts</h3>
        <p>Omogućava brži rad na blagajni pomoću tipkovnice.</p>

        <h4 class="mt-3">Omogući keyboard shortcuts na tipkovnici</h4>
        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Uključeno (ON)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Proizvodi i kategorije se mogu birati tipkama na tipkovnici</li>
                  <li>Kategorije: brojevi 1-9</li>
                  <li>Proizvodi: prva 2 slova naziva (npr. "Coca Cola" → CC)</li>
                  <li>Stolovi: brojevi stolova (npr. tipka "5" za stol 5)</li>
                  <li>Funkcijski gumbi: F (pretraga), T (stolovi), S (spremi), G (gotovina), K (kartično)</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>Isključeno (OFF)</strong></td>
              <td>Tipkovnički prečaci su onemogućeni - sve radnje se obavljaju klikom miša</td>
            </tr>
          </tbody>
        </table>

        <h4 class="mt-3">Prikaži shortcuts na ekranu</h4>
        <p><em>Ova opcija je vidljiva samo kada su keyboard shortcuts uključeni.</em></p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Uključeno (ON)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Na svakom tile-u (kategoriji/proizvodu) prikazuje se mali badge s prečacem</li>
                  <li>Badge je bijele boje, u donjem desnom kutu tile-a</li>
                  <li>Olakšava učenje i korištenje shortcuts-a</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>Isključeno (OFF)</strong></td>
              <td>Badge-vi nisu vidljivi. Korisnik mora znati shortcuts iz memorije ili držati Space tipku za privremeni prikaz</td>
            </tr>
          </tbody>
        </table>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Držite <strong>Space (razmaknica)</strong> tipku duže od 0.6 sekundi za privremeni prikaz svih shortcuts-a na ekranu. Kada pustite tipku, badge-vi nestaju.
          </div>
        </div>

        <h3 class="mt-4">2. Zatvori modal pri odabiru proizvoda</h3>
        <p>Kontrolira ponašanje dijaloga za odabir proizvoda iz kategorije.</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Opis</th>
              <th>Kada koristiti</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Uključeno (ON)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Klik na proizvod: proizvod se dodaje na račun</li>
                  <li>Modal se <strong>automatski zatvara</strong></li>
                  <li>Za dodavanje drugog proizvoda morate ponovno otvoriti modal</li>
                </ul>
              </td>
              <td>Brza usluga - obično se dodaje samo 1 proizvod iz kategorije (npr. brza hrana, prodavaonica)</td>
            </tr>
            <tr>
              <td><strong>Isključeno (OFF)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Klik na proizvod: proizvod se dodaje na račun</li>
                  <li>Modal <strong>ostaje otvoren</strong></li>
                  <li>Možete dodati više proizvoda uzastopno</li>
                  <li>Modal zatvarate ručno (klik na X ili izvan modala)</li>
                </ul>
              </td>
              <td>Restoran, caffe bar - često se dodaje više proizvoda iz iste kategorije (više pića, jela)</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">3. Koristi barcode scanner</h3>
        <p>Omogućava skeniranje barcoda pomoću USB/Bluetooth barcode čitača.</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Uključeno (ON)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Sustav sluša unos s barcode čitača</li>
                  <li>Skenirani proizvodi se automatski dodaju na račun</li>
                  <li>Potreban je barcode čitač spojen na uređaj</li>
                  <li>Proizvodi moraju imati definirane barcodes</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>Isključeno (OFF)</strong></td>
              <td>Barcode skeniranje je onemogućeno. Proizvodi se dodaju klikom ili shortcuts-ima</td>
            </tr>
          </tbody>
        </table>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Napomena:</strong> Barcode čitač mora biti konfiguriran kao USB HID uređaj (keyboard emulation mode). Za pomoć pri postavljanju kontaktirajte podršku.
          </div>
        </div>

        <h3 class="mt-4">4. Koristi tlocrt</h3>
        <p>Mijenja način prikaza stolova - lista vs. vizualni tlocrt.</p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Opis</th>
              <th>Vizualni prikaz</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Uključeno (ON)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Stolovi se prikazuju kao <strong>vizualni tlocrt</strong></li>
                  <li>Vidite raspored stolova kao u fizičkom prostoru</li>
                  <li>Stolovi su prikazani kao pravokutnici/krugovi na canvasu</li>
                  <li>Različite prostorije/sobe prikazane kao tab-ovi</li>
                  <li>Stolovi mogu biti različitih veličina i boja</li>
                </ul>
              </td>
              <td>
                🪑🪑🪑<br>
                🪑🪑🪑<br>
                🟢🔴🟠 (statusi stolova)
              </td>
            </tr>
            <tr>
              <td><strong>Isključeno (OFF)</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Stolovi se prikazuju kao <strong>lista/grid</strong></li>
                  <li>Jednostavan prikaz - kartice/gumbi s brojevima stolova</li>
                  <li>Brži za klikanje, manje vizualan</li>
                  <li>Preporučeno za brzu hranu ili prodavaonice</li>
                </ul>
              </td>
              <td>
                [Stol 1] [Stol 2] [Stol 3]<br>
                [Stol 4] [Stol 5] [Stol 6]
              </td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">5. Edit Mode (Edit On/Off)</h3>
        <p><em>Ova opcija je u glavnom gear dropdown menu-u, ne u dialogu.</em></p>

        <table class="info-table">
          <thead>
            <tr>
              <th>Mod</th>
              <th>Što omogućava</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Edit ON</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Uređivanje tile-ova (dodavanje, brisanje, editiranje)</li>
                  <li>Spajanje i razdvajanje ćelija</li>
                  <li>Promjena boja i efekata tile-ova</li>
                  <li>Mijenjanje dimenzija grid-a (redaka i stupaca)</li>
                  <li>Spremanje i učitavanje layout-a (prikaza)</li>
                  <li>Tile-ovi se NE dodaju na račun pri kliku</li>
                </ul>
              </td>
            </tr>
            <tr>
              <td><strong>Edit OFF</strong></td>
              <td>
                <ul style="margin: 0; padding-left: 20px;">
                  <li>Normalan rad na blagajni</li>
                  <li>Klik na tile dodaje proizvod/kategoriju na račun</li>
                  <li>Ne možete uređivati tile-ove</li>
                  <li>Grid je "zaključan"</li>
                </ul>
              </td>
            </tr>
          </tbody>
        </table>

        <h2 id="how-settings-work" class="mt-6">Kako postavke funkcioniraju</h2>

        <h3 class="mt-4">Spremanje postavki</h3>
        <ul>
          <li><strong>Lokalno spremanje:</strong> Sve postavke se spremaju u localStorage preglednika</li>
          <li><strong>Po blagajni:</strong> Svaka blagajna ima svoje postavke (ključ: <code>keyboard_shortcuts_&lt;cash_register_id&gt;</code>)</li>
          <li><strong>Automatsko spremanje:</strong> Promjene se odmah spremaju pri kliku na switch</li>
          <li><strong>Bez ponovnog učitavanja:</strong> Postavke se primjenjuju odmah, bez refresha stranice</li>
        </ul>

        <h3 class="mt-4">Učitavanje postavki</h3>
        <ul>
          <li>Postavke se učitavaju pri otvaranju blagajne</li>
          <li>Ako nema spremljenih postavki, koriste se default vrijednosti (sve isključeno)</li>
          <li>Postavke ostaju nakon zatvaranja preglednika</li>
        </ul>

        <h2 id="best-practices" class="mt-6">Najbolje prakse</h2>

        <h3 class="mt-4">Za restorane i caffe barove:</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Preporuka</th>
              <th>Razlog</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Keyboard shortcuts</td>
              <td>✓ Uključeno</td>
              <td>Brži rad, manje klikanja</td>
            </tr>
            <tr>
              <td>Prikaži shortcuts</td>
              <td>✓ Uključeno (u početku)</td>
              <td>Lakše učenje shortcuts-a</td>
            </tr>
            <tr>
              <td>Zatvori modal</td>
              <td>✗ Isključeno</td>
              <td>Često se dodaje više pića/jela iz kategorije</td>
            </tr>
            <tr>
              <td>Koristi tlocrt</td>
              <td>✓ Uključeno</td>
              <td>Vizualni prikaz stolova olakšava rad</td>
            </tr>
            <tr>
              <td>Barcode scanner</td>
              <td>✗ Isključeno</td>
              <td>Restorani obično ne koriste barcodes</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Za prodavaonice:</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Postavka</th>
              <th>Preporuka</th>
              <th>Razlog</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Keyboard shortcuts</td>
              <td>~ Opcionalno</td>
              <td>Ovisi o tome koristite li barcode scanner</td>
            </tr>
            <tr>
              <td>Zatvori modal</td>
              <td>✓ Uključeno</td>
              <td>Brža usluga za pojedinačne proizvode</td>
            </tr>
            <tr>
              <td>Koristi tlocrt</td>
              <td>✗ Isključeno</td>
              <td>Prodavaonice nemaju stolove</td>
            </tr>
            <tr>
              <td>Barcode scanner</td>
              <td>✓ Uključeno</td>
              <td>Najbrži način skeniranja proizvoda</td>
            </tr>
          </tbody>
        </table>

        <h2 id="troubleshooting" class="mt-6">Rješavanje problema</h2>

        <details>
          <summary>Keyboard shortcuts ne rade?</summary>
          <p>Provjere:</p>
          <ol>
            <li>Je li postavka "Omogući keyboard shortcuts" uključena?</li>
            <li>Je li kursor u input polju? (shortcuts ne rade u poljima za unos teksta)</li>
            <li>Testirajte s jednostavnim shortcutom: pritisnite "F" za pretragu</li>
            <li>Osvježite stranicu (F5) i pokušajte ponovno</li>
            <li>Provjerite u konzoli preglednika ima li grešaka</li>
          </ol>
        </details>

        <details>
          <summary>Badge-vi shortcuts-a se ne prikazuju?</summary>
          <ol>
            <li>Provjerite je li "Prikaži shortcuts na ekranu" uključeno</li>
            <li>Keyboard shortcuts moraju biti uključeni prvo</li>
            <li>Osvježite stranicu</li>
            <li>Provjerite je li tile aktivan (ima li proizvod/kategoriju)</li>
            <li><strong>Alternativa:</strong> Držite Space tipku za privremeni prikaz</li>
          </ol>
        </details>

        <details>
          <summary>Barcode scanner ne čita barcodes?</summary>
          <p>Dijagnostika:</p>
          <ol>
            <li>Je li "Koristi barcode scanner" uključeno?</li>
            <li>Je li čitač pravilno spojen (USB ili Bluetooth)?</li>
            <li>Testirajte čitač u Notepadu - trebao bi upisivati brojeve</li>
            <li>Provjerite je li čitač u HID/Keyboard emulation modu</li>
            <li>Provjerite ima li proizvod definiran barcode u sustavu:
              <ul>
                <li>Artikli → Odaberi proizvod → Provjeri polje "Barcodes"</li>
              </ul>
            </li>
          </ol>
        </details>

        <details>
          <summary>Modal se ne zatvara/zatvara se prebrzo?</summary>
          <p>Provjerite postavku "Zatvori modal pri odabiru proizvoda":</p>
          <ul>
            <li><strong>Problem:</strong> Modal se zatvara, a želim dodati više proizvoda
              <ul>
                <li><strong>Rješenje:</strong> Isključite "Zatvori modal pri odabiru proizvoda"</li>
              </ul>
            </li>
            <li><strong>Problem:</strong> Modal ostaje otvoren, a želim brži rad
              <ul>
                <li><strong>Rješenje:</strong> Uključite "Zatvori modal pri odabiru proizvoda"</li>
              </ul>
            </li>
          </ul>
        </details>

        <details>
          <summary>Želim resetirati sve postavke na default?</summary>
          <p>Za reset postavki:</p>
          <ol>
            <li>Otvorite Developer Tools (F12)</li>
            <li>Idite na tab "Console"</li>
            <li>Utipkajte: <code>localStorage.removeItem('keyboard_shortcuts_' + 'CASH_REG_ID')</code>
              <br><em>(zamijenite CASH_REG_ID s ID-em vaše blagajne)</em>
            </li>
            <li>Ili jednostavnije: <code>localStorage.clear()</code> (briše SVE lokalne postavke!)</li>
            <li>Osvježite stranicu (F5)</li>
          </ol>
          <div class="warning-box">
            <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
            <div>
              <strong>Oprez:</strong> <code>localStorage.clear()</code> briše SVE lokalne postavke, uključujući i login session. Morat ćete se ponovno prijaviti.
            </div>
          </div>
        </details>

        <details>
          <summary>Kako prilagoditi shortcuts za moje proizvode?</summary>
          <p>Shortcuts se generiraju automatski prema pravilima:</p>
          <ul>
            <li><strong>Kategorije:</strong> Brojevi 1-9 (prema redoslijedu)</li>
            <li><strong>Proizvodi:</strong> Prva 2 slova naziva
              <ul>
                <li>Primjer: "Coca Cola" → shortcut "CC"</li>
                <li>Primjer: "Ožujsko pivo" → shortcut "OP"</li>
              </ul>
            </li>
            <li><strong>Za bolje shortcuts-e:</strong> Preimenujte proizvode tako da im prva 2 slova budu jedinstvena</li>
            <li><strong>Rezervirana slova:</strong> F, T, S, O, G, K (zamijenjuju se sa X)</li>
          </ul>
          <p>Detaljnije o pravilima shortcuts-a pogledajte u <strong>"Caffe template → Keyboard shortcuts"</strong></p>
        </details>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Profesionalni savjet:</strong> Uključite keyboard shortcuts i badge prikaz u početku. Nakon što osoblje nauči shortcuts (obično 1-2 tjedna), možete isključiti badge prikaz za čišći izgled. Shortcuts će i dalje raditi!
          </div>
        </div>
      `
    }
  ]
}
